import React from 'react';
import Tippy from '../ReactTippy';
import _ from 'lodash';

/**
 * 編集テーブル表示部分
 * @param {LwUsers} lwUsers 表示するユーザーデータ
 * @param {boolean} isSso SSOを利用しているか否か
 * @param {number[]} checkedUserIds チェック済みユーザーのID配列
 * @param {function} setcheckedUserIds チェック済みユーザーを更新する関数
 **/
function RenderEditTable({
  lwUsers,
  isSso,
  checkedUserIds,
  setCheckedUserIds,
}) {
  const {
    toggleCheckById,
    isChekedById,
    toggleAllCheck,
    isAllCheked,
  } = useCheckBoxData(
    lwUsers.getNormalIds(isSso),
    checkedUserIds,
    setCheckedUserIds
  );
  return (
    <React.Fragment>
      <RenderEditTableHeader
        isAllCheked={isAllCheked}
        toggleAllCheck={toggleAllCheck}
      />
      <RenderEditTableBody
        lwUsers={lwUsers}
        isSso={isSso}
        isChekedById={isChekedById}
        toggleCheckById={toggleCheckById}
      />
    </React.Fragment>
  );
}

function RenderEditTableHeader({ isAllCheked, toggleAllCheck }) {
  return (
    <table className='table table-lw-user-manage-label'>
      <thead className='table__header'>
        <tr className='table__label'>
          <td className='value-table value-table__checkbox'>
            <div className='value-table__icon'>
              <div className='btn-checkbox-mini'>
                <label className='checkbox'>
                  <input
                    type='checkbox'
                    checked={isAllCheked()}
                    onChange={toggleAllCheck}
                  />
                  <i className='i-square i-3x' />
                </label>
              </div>
            </div>
          </td>
          <td className='value-table value-table__company_name'>会社名</td>
          <td className='value-table value-table__role_name'>ユーザー種別</td>
          <td className='value-table value-table__fullname'>氏名</td>
          <td className='value-table value-table__line_works_id'>
            LINE WORKS ID
          </td>
          <td className='value-table value-table__after_space' />
        </tr>
      </thead>
    </table>
  );
}

function RenderEditTableBody({
  lwUsers,
  isSso,
  isChekedById,
  toggleCheckById,
}) {
  return (
    <div className='lw-user-manage-element'>
      <table className='table'>
        <tbody className='table__body'>
          {lwUsers.list.map(user => (
            <RenderEditTableBodyRow
              key={user.id}
              user={user}
              isSso={isSso}
              isChekedById={isChekedById}
              toggleCheckById={toggleCheckById}
            />
          ))}
          {lwUsers.isEmpty() && (
            <tr className='table-has-no-data'>
              <td className='table-has-no-data__message'>データがありません</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

function RenderEditTableBodyRow({
  user,
  isSso,
  isChekedById,
  toggleCheckById,
}) {
  const user_id = user.id;
  const toggle_check = e => {
    const tagName = _.get(e, 'target.tagName');
    if (tagName !== 'INPUT') {
      toggleCheckById(user_id);
    }
  };
  const isNormal = _.isEmpty(user.getErrorMessageList(isSso));
  return (
    <tr
      className={isNormal ? 'table__item' : 'table__item table__item-disabled'}
      onClick={isNormal ? toggle_check : null}
    >
      <td className='value-table value-table__checkbox'>
        <div className='value-table__icon'>
          {isNormal ? (
            <div className='btn-checkbox-mini'>
              <label className='checkbox'>
                <input
                  checked={isChekedById(user.id)}
                  className='input-checkbox'
                  type='checkbox'
                  onChange={() => null}
                />
                <i className='i-square i-3x' />
              </label>
            </div>
          ) : (
            <div className='btn-checkbox-mini btn-checkbox-mini-disabled'>
              <RenderLwTippy
                html={user.getErrorMessageList(isSso).map((message, index) => (
                  <div key={index} className='lw-caution-tooltip-content'>
                    {message}
                  </div>
                ))}
              >
                <i className='i-warning' />
              </RenderLwTippy>
            </div>
          )}
        </div>
      </td>
      <td className='value-table value-table__company_name'>
        <RenderLwTippy
          html={<div className='lw-tooltip-content'>{user.company_name}</div>}
        >
          <div className='value-table__text'>{user.company_name}</div>
        </RenderLwTippy>
      </td>
      <td className='value-table value-table__role_name'>{user.role_name}</td>
      <td className='value-table value-table__fullname'>
        <RenderLwTippy
          html={<div className='lw-tooltip-content'>{user.full_name}</div>}
        >
          <div className='value-table__text'>{user.full_name}</div>
        </RenderLwTippy>
      </td>
      <td className='value-table value-table__line_works_id'>
        {user.line_works_id}
      </td>
    </tr>
  );
}

/**
 * 閲覧テーブル表示部分
 * @param {LwUsers} lwUsers 表示するユーザーデータ
 **/
function RenderShowTable({ lwUsers }) {
  return (
    <React.Fragment>
      <RenderShowTableHeader />
      <RenderShowTableBody lwUsers={lwUsers} />
    </React.Fragment>
  );
}

function RenderShowTableHeader() {
  return (
    <table className='table table-lw-user-manage-label'>
      <thead className='table__header'>
        <tr className='table__label'>
          <td className='value-table value-table__company_name'>会社名</td>
          <td className='value-table value-table__role_name'>ユーザー種別</td>
          <td className='value-table value-table__fullname'>氏名</td>
          <td className='value-table value-table__line_works_id'>
            LINE WORKS ID
          </td>
          <td className='value-table value-table__after_space' />
        </tr>
      </thead>
    </table>
  );
}

function RenderShowTableBody({ lwUsers }) {
  return (
    <div className='lw-user-manage-element'>
      <table className='table'>
        <tbody className='table__body'>
          {lwUsers.list.map(user => (
            <RenderShowTableBodyRow user={user} key={user.id} />
          ))}
          {lwUsers.isEmpty() && (
            <div className='table-has-no-data'>
              <span className='table-has-no-data__message'>
                データがありません
              </span>
            </div>
          )}
        </tbody>
      </table>
    </div>
  );
}

function RenderShowTableBodyRow({ user }) {
  // TODO：将来的にはSSO情報を取得して値を入れるようにする
  // 現状、この関数はトークルームの閲覧でしか利用せず、
  // トークルームユーザーのgetErrorMessageListではisSsoを利用しないことから無理やりnullにしているが、
  // 本来この関数は上記のことを知らないで利用できるようにするべきである。
  const isSso = null;
  return (
    <tr
      className={
        _.isEmpty(user.getErrorMessageList(isSso))
          ? 'table__item table__item-disabled'
          : 'table__item'
      }
    >
      <td className='value-table value-table__company_name'>
        <RenderLwTippy
          html={<div className='lw-tooltip-content'>{user.company_name}</div>}
        >
          <div className='value-table__text'>{user.company_name}</div>
        </RenderLwTippy>
      </td>
      <td className='value-table value-table__role_name'>{user.role_name}</td>
      <td className='value-table value-table__fullname'>
        <RenderLwTippy
          html={<div className='lw-tooltip-content'>{user.full_name}</div>}
        >
          <div className='value-table__text'>{user.full_name}</div>
        </RenderLwTippy>
      </td>
      <td className='value-table value-table__line_works_id'>
        {user.line_works_id}
      </td>
    </tr>
  );
}

// チェックボックスに関するステータスをコントロールするカスタムフック
function useCheckBoxData(all_ids, checkedUserIds, setCheckedUserIds) {
  const toggleCheckById = id => {
    setCheckedUserIds(prevStatus => {
      if (_.includes(prevStatus, id)) {
        return _.without(prevStatus, id);
      } else {
        return _.concat(prevStatus, [id]);
      }
    });
  };
  const isChekedById = id => {
    return _.includes(checkedUserIds, id);
  };
  const toggleAllCheck = () => {
    if (isAllCheked()) {
      setCheckedUserIds([]);
    } else {
      setCheckedUserIds(_.cloneDeep(all_ids));
    }
  };
  const isAllCheked = () => {
    // 選べるIDがひとつもない場合は、常に非選択状態とする。
    return (
      all_ids.length != 0 &&
      _.every(all_ids, id => _.includes(checkedUserIds, id))
    );
  };
  return { toggleCheckById, isChekedById, toggleAllCheck, isAllCheked };
}

function RenderLwTippy({ children, html }) {
  return (
    <Tippy
      duration={10}
      distance={24}
      arrow='true'
      arrowType='sharp'
      delay={[500, 0]}
      placement='bottom'
      followCursor={true}
      html={html}
    >
      {children}
    </Tippy>
  );
}

export { RenderEditTable, RenderShowTable };



// WEBPACK FOOTER //
// ./src/components/lwUser/table.jsx